import {ProjectActions} from "../../reducers/project/actionsNames";
import {Category, IAttributes} from "../../reducers/project";

export default (attr: IAttributes, custom = false) => ({
  type: ProjectActions.SelectAttr,
  attr,
  custom
})